import { downArrowWhite } from '../assets/images';

import { LinkType } from '.';

export interface TextType {
	title: string;
	body: string | React.ReactElement;
	image?: any;
	isbreadCrumbs?: boolean;
}

export const RiskProfileText: TextType = {
	title: 'Risk profile overview',
	body: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam molestiae autem, saepe ad et facere.',
};

export const ChangeEngineText: TextType = {
	title: 'Regulation change management',
	body: 'Keep up to date with the latest regulatory changes and how they may effect your business.',
	isbreadCrumbs: true,
};
export const RegulatoryInventoryLanding: TextType = {
	title: '',
	body: '',
	isbreadCrumbs: true,
};

export const MappingEngineText: TextType = {
	title: 'Mapping engine overview',
	body: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam molestiae autem, saepe ad et facere.',
};

export const GenerativeAIText: TextType = {
	title: 'GenerativeAI overview',
	body: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam molestiae autem, saepe ad et facere.',
};

export const ClusterReview: TextType = {
	title: 'Cluster review',
	body: '',
	isbreadCrumbs: true,
};

export const GRCText: TextType = {
	title: 'Change Engine Modified Changes Overview',
	body: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam molestiae autem, saepe ad et facere.',
};

export const ReportingText: TextType = {
	title: 'Reporting library',
	body: 'Stay on top of your compliance organization with focused interactive dashboards and industry-leading insights from PwC.',
	isbreadCrumbs: true,
};

export const RegulationChangeText: TextType = {
	title: 'Regulation change management',
	body: 'Keep up to date with the latest regulatory changes and how they may effect your business.',
	isbreadCrumbs: true,
};

export const RiskQuantificationText: TextType = {
	title: 'Risk quantification overview',
	body: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam molestiae autem, saepe ad et facere.',
};

export const TestMonitoringText: TextType = {
	title: 'Testing & monitoring',
	body: 'This page is designed to streamline your testing workflow, keeping you up-to-date with the latest control tests, pending action items, and important issues or observations.',
};

export const TestHubText: TextType = {
	title: 'Test hub',
	body: 'This page is designed to streamline your testing workflow, keeping you up-to-date with the latest control tests, pending action items, and important issues or observations.',
	isbreadCrumbs: true,
};

export const TestScriptHubText: TextType = {
	title: 'Test script hub',
	body: 'Make sure to check the library for existing tests.**More copy needed for this section.**',
	isbreadCrumbs: true,
};

export const ControlTestSelection: TextType = {
	title: 'Test script hub',
	body: 'Make sure to check the library for existing tests. **More copy needed for this section.**',
	isbreadCrumbs: true,
};

export const SettingsText: TextType = {
	title: 'Hey there!',
	body: "Welcome back, we're happy to have you here!",
};

export const TaxonomyText: TextType = {
	title: 'Risk reference taxonomy',
	body: "Browse from PwC's massive curated library, build a custom scenario, or leverage the advanced riskGPT feature.",
};

export const RiskRegulations: TextType = {
	title: 'Today’s Top Compliance Risks',
	body: 'June 29, 2023',
	image: downArrowWhite,
	isbreadCrumbs: true,
};

export const DataIngestionText: TextType = {
	title: 'Data ingestion',
	body: 'Quickly load your user, policy, process, and control data through our intuitive data upload workflow.',
	isbreadCrumbs: true,
};

export const ControlDeDuplicationText: TextType = {
	title: 'Control De-duplication',
	body: 'Last Executed:--/--/--',
	isbreadCrumbs: true,
};

export const RiskReferenceTaxonomyTitle: TextType = {
	title: 'PRC inventory',
	body: 'Browse from PwC’s massive, curated library or a GRC library.',
};

export const HorizonScanningPageTitle: TextType = {
	title: 'Horizon scanning',
	body: 'Stay well-informed by browsing through the most recent regulatory updates.',
};

export const regex = /^[A-Za-z0-9 ]+$/;

export const APIDateFormat = 'YYYY-MM-DD';

export const submissionFailedMsg =
	'Your submission could not be completed at this time. Please save your work and try to submit again shortly.';

export const AXIOS_NETWORK_ERR_CODE = 'ERR_NETWORK';

export const REG_INV_APPROVAL_ERROR_MSG =
	"We're unable to process your decision at this time. Please try again";

export const REG_INV_COMMENT_ERROR_MSG =
	'Failed to submit your comments. Please ensure all fields are filled out correctly and try again';

export const REG_INV_SUBMIT_ERROR_MSG =
	'Your submission could not be completed at this time. Please save your work and try to submit again shortly.';

export const APP_GENERAL_ERROR_MSG =
	"We're sorry, the service is currently unavailable. Please try again later.";

export const FEEDBACK_API_ERROR_MSG = 'Error fetching feedback data';

export const PWC = 'PWC';

export const appPages = {
	HOME_PAGE: 'Home page',
	PRC_INVENTORY_PAGE: 'PRC inventory',
	REG_CHANGE_PAGE: 'Regulation change',
};
export const NLP_ERR_MSG =
	'Unable to analyze the regulations at this time, please try again later.';

export const GENERIC_ERROR_MSG = 'An error occurred!';

export const REG_INV_NO_RECORDS_ERROR_MSG =
	'No results found for [search_text]. Please try a different keyword.';

export const PERMISSION_DENIED_ERROR_MSG =
	"You don't have permissions to perform this action.";

export const APP_GENERAL_CREATE_LABEL = 'Create';

export const APP_GENERAL_SAVE_LABEL = 'Save';

export const APP_GENERAL_CANCEL_LABEL = 'Cancel';

export const API_FAIL_ERROR_MESSAGE = 'Failed to fetch data';

export const APP_GENERIC_BAD_REQUEST_MSG =
	'Bad request, Please try again later.';

export const APP_GENERIC_DATA_NOT_FOUND_MSG =
	'Data Not Found, Please try again later.';

export const APP_RISK_LINK_DASHBOARD_CONSTANT = 'Welcome to Risk Link';

export const APP_ASK_RISK_LINK_CHAT_HISTORY_NOTIFICATION =
	'Inactive chat sessions and files will be deleted after 30 days';

export const APP_RISK_LINK_DASHBOARD_DESCRIPTION = `An intelligent solution that allows you to keep up with regulatory changes in real-time, easily understand the obligations for your business,
 and automatically map new regulations to your existing compliance, risk processes and internal controls.`;

export const APP_RISK_LINK_FOOTER_LINK_UNIVERSAL: LinkType = {
	label: 'Universal terms of service',
	link: 'https://productcentral.products.pwc.com/us/en/legal/terms-of-use.html',
};

export const APP_RISK_LINK_FOOTER_LINK_PRIVACY: LinkType = {
	label: 'Privacy statement',
	link: 'https://privacyhub.pwc.com/us/en/risk-link/privacy-policy.html',
};

export const APP_RISK_LINK_FOOTER_LINK_COOKIE: LinkType = {
	label: 'Cookie notice',
	link: 'https://privacyhub.pwc.com/us/en/risk-link/cookie-notice.html',
};

export const NO_DATA_FOUND = 'No Data Found';

export const ORANGE_THEME_TEXT = 'ORANGE THEME';

export const BLUE_THEME_TEXT = 'BLUE THEME';
